module.exports = __webpack_public_path__ + "img/allow-meeting-request.758b5911.jpg";